document.addEventListener("DOMContentLoaded", () => {
  // Function to increase quantity
  function increaseQuantity() {
    let quantityInput = document.getElementById("tw-product__quantity-input");
    let currentValue = parseInt(quantityInput.value);
    quantityInput.value = currentValue + 1;
  }

  // Function to decrease quantity
  function decreaseQuantity() {
    let quantityInput = document.getElementById("tw-product__quantity-input");
    let currentValue = parseInt(quantityInput.value);
    if (currentValue > 1) {
      quantityInput.value = currentValue - 1;
    }
  }

  // Accordion
  const accordionItems = document.querySelectorAll(".tw-accordion-item");

  accordionItems.forEach((item) => {
    const header = item.querySelector(".tw-accordion-header");
    const content = item.querySelector(".tw-accordion-content");

    header.addEventListener("click", () => {
      content.classList.toggle("active");
    });
  });

  // Tabs
  const tabButtons = document.querySelectorAll(".tw-tab-button");
  const tabContents = document.querySelectorAll(".tw-tab-content");

  // Function to switch tabs
  tabButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const targetTab = button.getAttribute("data-tab");

      // Remove "active" class from all buttons and contents
      tabButtons.forEach((btn) => btn.classList.remove("active"));
      tabContents.forEach((content) => content.classList.remove("active"));

      // Add "active" class to the clicked button and target content
      button.classList.add("active");
      document.getElementById(targetTab).classList.add("active");
    });
  });
});
